/******************************************
 *  Author : vsuthar
 *  Created On : Wed Sep 01 2021
 *  File : TestingDataIds.js
 *  ©Palo Alto Networks
 *******************************************/


/**
 * ================================
 *             CAUTION
 * ================================
 * ALL THE TESTING DATA-TESTID SHOULD GO HERE
 * USING THIS WE ENSURE THAT DATA-TESTID DONT COLLIDE AND UNIQUE.
 * THIS WILL ALSO HELP AUTOMATION TEAM TO LOOK AT SINGLE PLACE BY MODULE
 * PLEASE ENSURE YOU USE MODULE AND COMPNENT NAME IN COMMENT
 *
 */

// Global data-testids
export const DATA_TEST_DRAWER_CLOSE = 'drawer-close'

// BreadCrumbs data-testids

export const DATA_TEST_BREADCRUMB_LINK = 'breadcrumb-link-btn'
export const DATA_TEST_RIGHT_ICON = 'breadcrumb-icon'

//Tenancy Management related data-testids
export const DATA_TEST_ID_ROW_EXTERNAL_ICON = 'external_icon'
export const DATA_TEST_ID_ADD_TENANT_FORM_BUTTON_SUBMIT = 'add_tenant_form_button_submit'
export const DATA_TEST_TENANT_NAME = 'tenant-name'

//IAM management related data-testids
export const DATA_TEST_REMOVE_IDENTITY_MESSAGE = 'remove-identity-message'
export const DATA_TEST_REMOVE_IDENTITY_CONFIRM = 'remove-identity-confirm'
export const DATA_TEST_REMOVE_IDENTITY_CANCEL = 'remove-identity-cancel'
export const DATA_TEST_REMOVE_IDENTITY_SUBMIT = 'remove-identity-submit'
export const DATA_TEST_REMOVE_IDENTITY_BUTTON = 'remove-identity-button'

export const DATA_TEST_ADD_IDENTITY_ADDRESS = 'add-identity-address'
export const DATA_TEST_ADD_IDENTITY_CANCEL = 'add-identity-cancel'
export const DATA_TEST_ADD_IDENTITY_SUBMIT = 'add-identity-submit'
export const DATA_TEST_ADD_IDENTITY_TYPE = 'add-identity-type'

export const DATA_TEST_VIEW_IDENTITY_TYPE = 'view-identity-type'
export const DATA_TEST_VIEW_IDENTITY_ADDRESS = 'view-identity-address'
export const DATA_TEST_VIEW_IDENTITY_NAME = 'view-identity-name'
export const DATA_TEST_VIEW_IDENTITY_CANCEL = 'view-identity-cancel'
export const DATA_TEST_VIEW_IDENTITY_REMOVE = 'view-identity-remove'

export const DATA_TEST_SERVICE_ACCOUNT_NAME = 'service-account-name'
export const DATA_TEST_SERVICE_ACCOUNT_EMAIL = 'service-account-email'
export const DATA_TEST_SERVICE_ACCOUNT_CONTACT = 'service-account-contact'
export const DATA_TEST_SERVICE_ACCOUNT_DESC = 'service-account-desc'
export const DATA_TEST_CLIENT_SECRET = 'service-account-client-secret'
export const DATA_TEST_CLIENT_ID = 'service-account-client-id'
export const DATA_TEST_CSV = 'service-account-download-csv'

export const DATA_TEST_Z_INDEX = 'z-index'
export const DATA_TEST_SHOW_HIDE_PASSWORD = 'show-hide-password'

//Subscription related data-testids
export const DATA_TEST_TERMS_CHECKBOX = 'terms-conditions-checkbox'
export const DATA_TEST_SUB_ALLOCATION_RADIO = 'subscription-allocation-radio'

// Tenant Tree related data-testids
export const DATA_TEST_SEARCH_TREE_BUTTON = 'rc-tree-button'

//
export const DATA_TEST_ALLOCATE_LICENSE = 'allocate-license-toggle'

export const DATA_TEST_PERMISSION_INPUT = 'permissions-table-input'

// IDP data test ids
export const DATA_TEST_DOMAIN_SUBMIT_BUTTON = 'domain-submit-button'
export const DATA_TEST_DOMAIN_CANCEL_BUTTON = 'domain-cancel-button'
export const DATA_TEST_DOMAIN_FINISH_BUTTON = 'domain-finish-button'
export const DATA_TEST_DOMAIN_PREVIOUS_BUTTON = 'domain-previous-button'
export const DATA_TEST_DOMAIN_INPUT = 'domain-input'
export const DATA_TEST_SAML_CHOOSE_FILE = 'choose-file'
export const DATA_TEST_SAML_INPUT = 'url-input'
export const DATA_TEST_SAML_URL_BUTTON = 'get-url-button'
export const DATA_TEST_SAML_IDP_INPUT = 'idp-config-input'
export const DATA_TEST_SAML_CANCEL_BUTTON = 'saml-cancel-button'
export const DATA_TEST_SAML_NEXT_BUTTON = 'saml-next-button'
export const DATA_TEST_META_PREVIOUS_BUTTON = 'saml-meta-previous-button'
export const DATA_TEST_META_NEXT_BUTTON = 'saml-meta-next-button'
export const DATA_TEST_ACTIONS_GEAR = 'owners-table-gear-icon'
export const DATA_TEST_ACTIONS_TRASH = 'owners-table-trash-icon'
export const DATA_TEST_OWNERS_CANCEL_BUTTON = 'owners-cancel-button'
export const DATA_TEST_OWNERS_ADD_BUTTON = 'owners-add-button'
